/* import __COLOCATED_TEMPLATE__ from './add-owner.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { GovernmentIdType } from '@banking/api/models/onboarding/individual';
import { Validation } from '@banking/ui/utils/validation';
import { Address } from '@square/dashboard-protos/models/squareup/connect/v2/resources/address';
let AddOwner = (_class = class AddOwner extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "formId", _descriptor2, this);
    _initializerDefineProperty(this, "firstName", _descriptor3, this);
    _initializerDefineProperty(this, "middleName", _descriptor4, this);
    _initializerDefineProperty(this, "lastName", _descriptor5, this);
    _initializerDefineProperty(this, "address1", _descriptor6, this);
    _initializerDefineProperty(this, "address2", _descriptor7, this);
    _initializerDefineProperty(this, "city", _descriptor8, this);
    _initializerDefineProperty(this, "state", _descriptor9, this);
    _initializerDefineProperty(this, "zip", _descriptor10, this);
    _initializerDefineProperty(this, "dob", _descriptor11, this);
    _initializerDefineProperty(this, "ssn", _descriptor12, this);
    _initializerDefineProperty(this, "ssnSerialNumber", _descriptor13, this);
    _initializerDefineProperty(this, "isSignificantOwner", _descriptor14, this);
    this.firstName = args.individual.givenName;
    this.middleName = args.individual.middleName;
    this.lastName = args.individual.surname;
    this.address1 = args.individual.address?.addressLine1;
    this.address2 = args.individual.address?.addressLine2;
    this.city = args.individual.address?.locality;
    this.state = args.individual.address?.administrativeDistrictLevel1;
    this.zip = args.individual.address?.postalCode;
    this.dob = args.individual.birthDate;
    this.isSignificantOwner = args.individual.isSignificantOwner;
    if (args.individual.governmentId?.serialNumber) {
      this.ssnSerialNumber = args.individual.governmentId?.serialNumber.slice(-4);
    }
  }
  get firstNameValidation() {
    if (!this.firstName?.length) {
      return new Validation('First name is required');
    } else {
      return new Validation();
    }
  }
  get lastNameValidation() {
    if (!this.lastName?.length) {
      return new Validation('Last name is required');
    } else {
      return new Validation();
    }
  }
  get adddressLine1Validation() {
    if (!this.address1?.length) {
      return new Validation('Street is required');
    } else {
      return new Validation();
    }
  }
  get cityValidation() {
    if (!this.city?.length) {
      return new Validation('Street is required');
    } else {
      return new Validation();
    }
  }
  get stateValidation() {
    if (!this.state?.length) {
      return new Validation('State is required');
    } else {
      return new Validation();
    }
  }
  get zipValidation() {
    if (!this.zip?.length) {
      return new Validation('ZIP is required');
    } else if (!/[\d-]+/.test(this.zip)) {
      return new Validation('ZIP must only be numbers and dashes');
    } else {
      return new Validation();
    }
  }
  get dobValidation() {
    if (!this.dob?.year || !this.dob?.monthOfYear || !this.dob?.dayOfMonth) {
      return new Validation('Date of birth is required');
    } else {
      return new Validation();
    }
  }
  get tinValidation() {
    if (this.ssnSerialNumber) {
      return new Validation();
    } else if (!this.ssn || this.ssn.length < 9) {
      return new Validation('SSN is required');
    } else {
      return new Validation();
    }
  }

  // This assumes that _individual was constructed using the correct attributes
  // on this.component/this.args
  validate(_individual) {
    return this.firstNameValidation.isValid && this.lastNameValidation.isValid && this.adddressLine1Validation.isValid && this.cityValidation.isValid && this.stateValidation.isValid && this.zipValidation.isValid && this.dobValidation.isValid && this.tinValidation.isValid;
  }
  onIsSignificantOwnerChange(event) {
    this.isSignificantOwner = event.detail.current === true;
  }
  updateTin(value) {
    this.ssnSerialNumber = undefined;
    this.ssn = value;
  }

  // This action is attached to the market modal button and triggers the native
  // form submit event.
  // Prism forms work using the native events.
  onSave() {
    const form = document.getElementById(this.formId);
    if (form) {
      form.dispatchEvent(new Event('submit'));
    }
  }
  onSubmit() {
    const individual = {
      id: this.args.individual.id,
      isAccountOwner: this.args.individual.isAccountOwner,
      isManager: this.args.individual.isManager,
      isSignificantOwner: this.isSignificantOwner,
      givenName: this.firstName,
      middleName: this.middleName,
      surname: this.lastName,
      address: Address.fromObject({
        addressLine1: this.address1,
        addressLine2: this.address2,
        locality: this.city,
        administrativeDistrictLevel1: this.state,
        postalCode: this.zip
      }),
      birthDate: this.dob
    };
    if (this.ssnSerialNumber) {
      individual.governmentId = {
        type: GovernmentIdType.SSN,
        serialNumber: this.args.individual.governmentId?.serialNumber
      };
    } else {
      individual.governmentId = {
        type: GovernmentIdType.SSN,
        value: this.ssn
      };
    }
    if (this.validate(individual)) {
      this.args.save(individual);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'banking__add-owner__form';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "firstName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "middleName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "lastName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "address1", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "address2", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "city", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "state", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "zip", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "dob", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "ssn", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "ssnSerialNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "isSignificantOwner", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onIsSignificantOwnerChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onIsSignificantOwnerChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTin", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype), _class);
export { AddOwner as default };